<template>
  <div id="fusion_messaging_container" class="">
   <template v-if="page_type==='Spark' && showSparkSplash">
    <rey-welcome key="fusion_messaging_rey_welcome" @closeWelcome="$emit('closeSplash')" @sendMessage="sendMessage" @voiceInitiated="voice_initiated = true" />
   </template>
   <template v-else>
    <div :id="`${active_tab}Component_container`" class="w-full h-full">
     <div v-show="(page_type!=='Spark' || active_tab==='Chat') && !show_contacts_view && !show_open_contact_view && !show_chat_details_view && !show_spark_conversations" class="w-full h-full">
      <messenger-window key="fusion_messaging_messenger_window" class="messenger_window w-full h-full" :set-configuration="set_configuration"
                      :set-thread-id="setThreadId" :set-new-message="send_message" :set-voice-initiated="voice_initiated" :message-type="message_type" />
     </div>
     <!-- v-if, not v-show: the list refetches on mount so it is current every time the hamburger
          opens it. The messenger-window above stays MOUNTED behind it (v-show) so the open
          conversation, its scroll position and its bus subscriptions all survive the detour. -->
     <rey-conversation-list v-if="show_spark_conversations" key="fusion_messaging_rey_conversations" class="w-full h-full" />
     <contacts-list v-if="show_contacts_view" key="fusion_messaging_contacts_list" class="w-full h-full" />
     <enterprise-contact-details v-if="show_open_contact_view" key="fusion_messaging_open_contact" class="w-full h-full" />
     <chat-details v-if="show_chat_details_view" key="fusion_messaging_chat_details" class="w-full h-full" />
     <rey-recommendations v-show="page_type==='Spark' && active_tab==='Recommendations'" key="fusion_messaging_rey_recommendations" />
    </div>
   </template>
  </div>
</template>

<script>
  import MessengerWindow from '@components/Messaging/MessengerWindow.vue';
  import ContactsList from '@components/Messaging/ContactsList.vue';
  import EnterpriseContactDetails from '@components/Messaging/EnterpriseContactDetails.vue';
  import ChatDetails from '@components/Messaging/ChatDetails.vue';
  import ReyRecommendations from '@components/Rey/ReyRecommendations.vue';
  import ReyWelcome from '@components/Rey/ReyWelcome.vue';
  import ReyConversationList from '@components/Rey/ReyConversationList.vue';

  import { mapStores } from 'pinia';
  import { useMainStore } from '@store/main';

  export default {
   props: {
     setConfiguration: {
       type: Object,
       required: false,
       default: null
     },
     showSparkSplash: {
       type: Boolean,
       required: false,
       default: false
     },
     setThreadId: {
       type: String,
       required: false,
       default: null
     },
   },
   components: {
    'messenger-window': MessengerWindow,
    'contacts-list': ContactsList,
    'enterprise-contact-details': EnterpriseContactDetails,
    'chat-details': ChatDetails,
    'rey-recommendations': ReyRecommendations,
    'rey-welcome': ReyWelcome,
    'rey-conversation-list': ReyConversationList,
   },
   data() {
    return {
     send_message: '',
     voice_initiated: false
    }
   },
   computed: {
    ...mapStores(useMainStore),
    // Keys the messenger-window so it fully remounts when a different user authenticates in
    // this same SPA instance (same-device logout/login), clearing the child's component-local
    // thread selection so the previous user's thread is never re-requested.
    current_user_guid() {
     return this.mainStore.user_access_info?.userId || null;
    },
    internal_messaging_state() {
     return this.mainStore.internal_messaging_state;
    },
    has_chat_access() {
     return this.mainStore.has_chat_access;
    },
    show_contacts_view() {
     // Contacts subview requires chat access (the DM start path). TAC-only users shouldn't
     // see it even if the state somehow got set.
     return this.page_type === 'InternalMessaging' && this.internal_messaging_state === 'Contacts' && this.has_chat_access;
    },
    show_open_contact_view() {
     return this.page_type === 'InternalMessaging' && this.internal_messaging_state === 'OpenContact';
    },
    show_chat_details_view() {
     return this.page_type === 'InternalMessaging' && this.internal_messaging_state === 'ChatDetails';
    },
    spark_view() {
     return this.mainStore.spark_view;
    },
    // Gated on page_type so the InternalMessaging body — which mounts its own copy of this view in
    // the toolbar layout — never swaps its chat window for the Rey conversation list.
    show_spark_conversations() {
     return this.page_type === 'Spark' && this.spark_view === 'Conversations';
    },
    set_configuration() {
     let fieldData = {};
     if(this.$FUSobjectHasFields(this.setConfiguration))
      fieldData = this.$FUSjsonCopy(this.setConfiguration);
     if (!fieldData.hasOwnProperty('FuseConfigurations'))
      fieldData['FuseConfigurations'] = {};
     if(!fieldData.FuseConfigurations.hasOwnProperty('InputConfiguration')) {
      fieldData.FuseConfigurations.InputConfiguration = {
       bottomButtons: true,
       fileUpload3: true,
       send3: true,
      };
     }
          
     return fieldData;
    },
    page_type() {
     return this.set_configuration?.PageType;
    },
    active_tab() {
     return this.set_configuration?.FuseConfigurations?.ActiveTab;
    },
    message_type() {
     return this.page_type==='InternalMessaging'?this.active_tab:null;
    },
   },
   methods: {
    sendMessage(message) {
     this.$emit('closeSplash');
     this.send_message = message;
    }
   },
  }
</script>
